export enum CmmStpStatus {
  APPROVED = "Approved",
  DENIED = "Denied",
  PENDING = "Pending",
  AUTH_NOT_REQUIRED = "Auth Not Required",
  APPROVAL_ON_FILE = "Approval on File",
  DENIAL_ON_FILE = "Denial on File",
  CASE_ON_FILE = "Case on File",
  NOT_CORRECT_PROCESSOR = "Not Correct Processor",
  DRUG_NOT_COVERED = "Drug Not Covered",
  NON_EPA = "Non-ePA",
  OTHER_PLATFORMS = "Other Platforms",
  PA_RESOLVED = "PA Resolved",
  NA_OUTCOME = "NA Outcome",
  WAITING_FOR_CLINICAL = "Waiting For Clinical",
  ONSHORE_ASSISTANCE = "Onshore Assistance",
  SEND_TO_CLIENT = "Send To Client",
  SENT_TO_PLAN = "sent_to_plan",
}
